
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'
import { MapChart } from 'echarts/charts'
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  VisualMapComponent
} from 'echarts/components'
import VChart from 'vue-echarts'
import { exportCanvasAsPng } from '@/utils/enerEchartsFunctions'

use([
  CanvasRenderer,
  UniversalTransition,
  MapChart,
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  VisualMapComponent
])

export default {
  name: 'EnerEchartsMap',
  components: {
    VChart
  },
  props: {
    download: {
      type: Boolean,
      default: false
    },
    title: {
      required: false,
      type: String,
      default: ''
    },
    filename: {
      required: false,
      type: String,
      default: ''
    },
    option: {
      type: Object,
      default () {
        return {}
      }
    },
    initOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    updateOptions: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  watch: {
    download: {
      async handler () {
        if (this.download === true) {
          const canvas = this.$refs.map.getDom().getElementsByTagName('canvas')[0]
          await exportCanvasAsPng(canvas, this.filename, this.title)
          this.$emit('exporting')
        }
      }
    }
  },
  methods: {
    handleSelectChanged (event) {
      this.$emit('mapSelect', event.selected)
    }
  }
}
